import { render, staticRenderFns } from "./LuckyBagPopup.vue?vue&type=template&id=602fb432&scoped=true"
import script from "./LuckyBagPopup.vue?vue&type=script&lang=js"
export * from "./LuckyBagPopup.vue?vue&type=script&lang=js"
import style0 from "./LuckyBagPopup.vue?vue&type=style&index=0&id=602fb432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602fb432",
  null
  
)

export default component.exports